<div class="container">
  <div class="row">
    <div class="title">
      {{
      isTp ? ("help.titleTp" | translate) : ("help.title" | translate)
      }}
    </div>
  </div>
  <div class="marginTop cardsBlock row row-gap-3">
    <div class="col-12 col-sm-6 col-md-4">
      <div class="cardContainer">
        <div class="cardTitle">
          {{ "help.cards.awareness.title" | translate }}
        </div>
        <div>{{ "help.cards.awareness.subtitle" | translate }}</div>
        <img src="assets/help/isc.png" draggable="false" />
        <div
          (click)="openLink('https://www.internetsanscrainte.fr/')"
          class="linkContainer"
          >
          <div>{{ "help.cards.awareness.button" | translate }}</div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-6 col-md-4">
      <div class="cardContainer">
        <div class="cardTitle">
          {{ "help.cards.report.title" | translate }}
        </div>
        <div>{{ "help.cards.report.subtitle" | translate }}</div>
        <img src="assets/help/pdc.png" draggable="false" />
        <div
          (click)="openLink('https://www.pointdecontact.net/')"
          class="linkContainer"
          >
          <div>{{ "help.cards.report.button" | translate }}</div>
        </div>
      </div>
    </div>
    <div class="col-12 col-sm-6 col-md-4">
      <div class="cardContainer">
        <div class="cardTitle">
          {{ "help.cards.protection.title" | translate }}
        </div>
        <div>{{ "help.cards.protection.phone" | translate }}</div>
        <img src="assets/help/ee.jpg" draggable="false" />
        <div
          (click)="openLink('https://e-enfance.org/')"
          class="linkContainer"
          >
          <div>{{ "help.cards.protection.button" | translate }}</div>
        </div>
      </div>
    </div>
  </div>
  @if (isTp) {
    <div class="row videoRow">
      <div class="col-12 videoBlock">
        <iframe
          class="video"
          src="https://www.youtube-nocookie.com/embed/nB4cHsPl4iw?si=4NundAxTxaGU_ssl&rel=0"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  }
  <div class="row videoRow">
    <div class="col-12 videoBlock">
      <iframe
        class="video"
        src="https://www.youtube-nocookie.com/embed/Aawf1O7TKbs?si=Fx8N0iL2ZnsvCh7m&rel=0"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        allowfullscreen
      ></iframe>
    </div>
  </div>
  <div class="lineContainer marginTop row">
    <div class="col-12 col-md-6">
      <div class="subtitle">
        #BetterInternetForKids #SafeInternetFrance
      </div>
    </div>
  </div>
</div>
